import type { FallbackProps } from '@gik/core/api/BaseAPIConfig';
import { ISRRevalidateTimeout, baseFallback } from '@gik/core/api/BaseAPIConfig';
import { withTitle } from '@gik/core/hocs/withTitle';
import { catchSSRError } from '@gik/core/utils/catchSSRError';
import { measureSSRPerformance } from '@gik/core/utils/measureSSRPerformance';
import { CommonQuestionsPage } from '@gik/marketing/pages/CommonQuestionsPage';
import type { CommonQuestionsPageServerProps } from '@gik/marketing/pages/CommonQuestionsPage/CommonQuestionsPage';
import { getFaq } from '@/api/acf/gik-settings/faq';
import type { PageLayoutProps } from '@/components/layout/PageLayout';
import { PageLayout } from '@/components/layout/PageLayout';
import { SWRConfig } from 'swr';

export default function CommonQuestionsPageComp({ fallback }: FallbackProps<CommonQuestionsPageServerProps>) {
  return withTitle(
    'Common Questions',
    <SWRConfig value={{ fallback }}>
      <CommonQuestionsPage />
    </SWRConfig>
  );
}

CommonQuestionsPageComp.getLayout = function getLayout(page, layoutProps: PageLayoutProps) {
  return (
    <PageLayout {...layoutProps} key={layoutProps.key}>
      {page}
    </PageLayout>
  );
};

async function _getStaticProps() {
  const faq = getFaq();

  return baseFallback(
    {
      [faq.key]: await faq.json,
    },
    undefined,
    ISRRevalidateTimeout.sitemapSlow
  );
}

export const getStaticProps = catchSSRError(measureSSRPerformance(_getStaticProps));
